import { UnitTransferScopeEnumType } from '__generated__/graphql';

export default function unitTransferScopeToReadable(scope: UnitTransferScopeEnumType): string {
  switch (scope) {
    case UnitTransferScopeEnumType.AllUnitsAllSchemes:
      return 'All units across all schemes';
    case UnitTransferScopeEnumType.AllUnitsSelectedSchemes:
      return 'All units in selected schemes';
    default:
      return scope;
  }
}
